import { authenticatedFetch } from './auth.service';
const BASE = `${process.env.REACT_APP_API_BASE_URL || 'https://admin.goridesrw.com/api/remote'}/driver-portal`;
async function request(path, method = 'GET', body) {
  const multipart = body instanceof FormData;
  const response = await authenticatedFetch(`${BASE}${path}`, {
    method,
    ...(body ? { body: multipart ? body : JSON.stringify(body), headers: multipart ? {} : { 'Content-Type': 'application/json' } } : {}),
  });
  if (response.status === 204 || response.headers.get('content-length') === '0') return null;
  const text = await response.text();
  const data = text ? JSON.parse(text) : null;
  if (!response.ok) throw new Error(data?.message || data?.detail || 'Unable to complete the request');
  return data;
}
export const driverService = {
  account: () => request('/account'),
  enableOwner: () => request('/owner-capability', 'POST'),
  register: (body) => request('/profile', 'PUT', body),
  uploadPicture: (file) => { const data = new FormData(); data.append('file', file); return request('/profile-picture', 'POST', data); },
  upload: (kind, file) => { const data = new FormData(); data.append('file', file); return request(`/documents/${kind}`, 'POST', data); },
  updateWeeklySlot: (id, body) => request(`/availability/weekly/${id}`, 'PUT', body),
  addWeeklySlot: (body) => request('/availability/weekly', 'POST', body),
  addSlot: (body) => request('/availability', 'POST', body),
  removeSlot: (id) => request(`/availability/${id}`, 'DELETE'),
  search: (start, end) => request(`/drivers?${new URLSearchParams({ startsAt: start, endsAt: end })}`),
  messages: (id) => request(`/trips/${id}/messages`),
  sendMessage: (id, content) => request(`/trips/${id}/messages`, 'POST', { content }),
  trips: () => request('/trips'),
  book: (body) => request('/trips', 'POST', body),
  action: (id, action, body) => request(`/trips/${id}/${action}`, 'POST', body),
};
